// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8dcadb2c","703":"9d602a4a"}[chunkId] + ".chunk.js";
};